(() => {
// funnel.ts
// ------------------------------------------------------
// 1. Define the event type enum
// ------------------------------------------------------
var $9ba21a0907c543ce$export$3d7865934588d77e;
(function(EventType) {
    EventType["LANDING_PAGE_VIEW"] = "landing_page_view";
    EventType["DEMO_START"] = "demo_start";
    EventType["APP_PAGE_VIEW"] = "app_page_view";
    EventType["SIGNUP"] = "signup";
    EventType["ACTIVE_SESSION"] = "active_session";
})($9ba21a0907c543ce$export$3d7865934588d77e || ($9ba21a0907c543ce$export$3d7865934588d77e = {}));
// ------------------------------------------------------
// 4. Hardcoded Webhook URL
// ------------------------------------------------------
const $9ba21a0907c543ce$var$WEBHOOK_URL = "https://sheet.rocks/workbook/VzuJyx97jtMOaxy/webhooks/track_any-origin";
// const WEBHOOK_URL = 'https://dev.sheet.rocks/workbook/1S5uQWR6n3OWA56/webhooks/track_any-origin';
// const WEBHOOK_URL = 'http://localhost:8080/workbook/iqnvvbfa6j4u066/track_any-origin';
// const WEBHOOK_URL = 'http://localhost:8080/workbook/iqnvvbfa6j4u066/webhooks/track_any-origin';
// ------------------------------------------------------
// 5. Helper methods (mostly unchanged)
// ------------------------------------------------------
function $9ba21a0907c543ce$var$getUserId() {
    const storedUserId = localStorage.getItem("sheetRocksUserId");
    if (storedUserId) return storedUserId;
    const randomInsects = [
        "fly",
        "ant",
        "bee",
        "butterfly",
        "dragonfly",
        "beetle",
        "grasshopper",
        "mosquito",
        "moth",
        "ladybug",
        "caterpillar",
        "cricket",
        "termite",
        "wasp",
        "roach",
        "firefly",
        "stickinsect",
        "weevil",
        "mayfly",
        "lacewing",
        "aphid",
        "hoverfly",
        "tsetse",
        "scorpion",
        "stickbug",
        "cicada",
        "bedbug",
        "leafcutter",
        "giantwaterbug",
        "silverfish",
        "earwig"
    ];
    const randomHash = Math.random().toString(36).slice(2, 11);
    const userId = `anonymous.${randomInsects[Math.floor(Math.random() * randomInsects.length)]}.${randomHash}`;
    localStorage.setItem("sheetRocksUserId", userId);
    return userId;
}
function $9ba21a0907c543ce$var$getSolution() {
    return localStorage.getItem("sheetRocksSolution") || "none";
}
function $9ba21a0907c543ce$export$7f5abdb7f5093137(userId) {
    localStorage.setItem("sheetRocksUserId", userId);
}
function $9ba21a0907c543ce$export$5b77291ef1caffe5(solution) {
    localStorage.setItem("sheetRocksSolution", solution);
}
function $9ba21a0907c543ce$var$getDeviceType() {
    const width = window.innerWidth;
    if (width <= 768) return "mobile";
    if (width <= 1024) return "tablet";
    return "desktop";
}
function $9ba21a0907c543ce$var$getTimezone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
// ------------------------------------------------------
// 6. Refactored sendEvent to handle everything in one place
// ------------------------------------------------------
function $9ba21a0907c543ce$var$sendEvent(eventType) {
    const timezone = $9ba21a0907c543ce$var$getTimezone();
    // if timezone is UTC, return -- do not track events in UTC
    if (timezone === "UTC") return;
    const eventData = {
        user_id: $9ba21a0907c543ce$var$getUserId(),
        event_type: eventType,
        solution: $9ba21a0907c543ce$var$getSolution(),
        meta: {
            page_url: window.location.href,
            device_type: $9ba21a0907c543ce$var$getDeviceType(),
            timezone: timezone
        }
    };
    fetch($9ba21a0907c543ce$var$WEBHOOK_URL, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(eventData)
    }).then((response)=>response.json()).then((data)=>console.log("Event sent successfully:", data)).catch((error)=>console.error("Error sending event:", error));
}
// ------------------------------------------------------
// 7. Simplified helper functions
// ------------------------------------------------------
function $9ba21a0907c543ce$var$trackPageView() {
    // If the page url containts get.sheet.rocks, send the landing page view event.
    if (window.location.href.includes("get.sheet.rocks")) $9ba21a0907c543ce$var$sendEvent("landing_page_view");
    else $9ba21a0907c543ce$var$sendEvent("app_page_view");
}
function $9ba21a0907c543ce$var$trackDemoStart() {
    $9ba21a0907c543ce$var$sendEvent("demo_start");
}
function $9ba21a0907c543ce$var$trackSignUp() {
    $9ba21a0907c543ce$var$sendEvent("signup");
}
function $9ba21a0907c543ce$var$initializeSolution() {
    const url = new URL(window.location.href);
    const utmCampaign = url.searchParams.get("utm_campaign");
    const project = url.searchParams.get("project");
    if (utmCampaign) $9ba21a0907c543ce$export$5b77291ef1caffe5(utmCampaign);
    else if (project) $9ba21a0907c543ce$export$5b77291ef1caffe5(project);
}
// ------------------------------------------------------
// 8. trackActiveSession with debounce logic
// ------------------------------------------------------
function $9ba21a0907c543ce$var$trackActiveSession() {
    const lastActiveSession = localStorage.getItem("sheetRocksLastActiveSession");
    const currentTime = new Date().getTime();
    // 30 minutes in milliseconds
    const THIRTY_MINUTES = 1800000;
    if (!lastActiveSession || currentTime - parseInt(lastActiveSession, 10) >= THIRTY_MINUTES) {
        $9ba21a0907c543ce$var$sendEvent("active_session");
        localStorage.setItem("sheetRocksLastActiveSession", currentTime.toString());
    } else console.log("Active session already tracked within the last 30 minutes.");
}
// ------------------------------------------------------
// 9. Attach event tracking to the window object
// ------------------------------------------------------
const $9ba21a0907c543ce$var$sheetRocksAnalytics = {
    trackPageView: $9ba21a0907c543ce$var$trackPageView,
    trackDemoStart: $9ba21a0907c543ce$var$trackDemoStart,
    trackSignUp: $9ba21a0907c543ce$var$trackSignUp,
    trackActiveSession: $9ba21a0907c543ce$var$trackActiveSession,
    setUserId: $9ba21a0907c543ce$export$7f5abdb7f5093137,
    setSolution: $9ba21a0907c543ce$export$5b77291ef1caffe5
};
window.sheetRocksAnalytics = $9ba21a0907c543ce$var$sheetRocksAnalytics;
// Call the page view event
$9ba21a0907c543ce$var$initializeSolution();
$9ba21a0907c543ce$var$trackPageView();

})();
//# sourceMappingURL=sheetRocksAnalytics.js.map
